import React from 'react';
import { Check, Layers, Building2 } from 'lucide-react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { structures } from './usContent';
import { UsSectionHeading, UsEnquireButton } from './UsElements';

export const UsStructureComparison = ({ onEnquire }) => (
  <section id="structures" className="uk-section uk-wrap" data-testid="us-structures-section">
    <UsSectionHeading id="us-structures" number="01" eyebrow="The right foundation" title="Choose the structure that fits your business." text="Start with your funding plans and how you will operate. Not just the filing fee." />
    <Tabs defaultValue="llc" className="uk-comparison" data-testid="us-structure-tabs">
      <TabsList className="uk-tabs" aria-label="Compare US business structures" data-testid="us-structure-tabs-list">
        {structures.map((item, index) => <TabsTrigger key={item.id} value={item.id} className="uk-tab" data-testid={`us-structure-tab-${item.id}`}>
          {index === 0 ? <Layers size={17} /> : <Building2 size={17} />}{item.short}
        </TabsTrigger>)}
      </TabsList>
      {structures.map(item => <TabsContent value={item.id} key={item.id} className="uk-tab-panel" data-testid={`us-structure-panel-${item.id}`}>
        <div className="uk-comparison-main">
          <span className="uk-eyebrow">{item.label}</span>
          <h3>{item.title}</h3><p>{item.intro}</p>
          <dl className="uk-fact-list">{item.facts.map(([label, text], i) => <div key={label} data-testid={`us-${item.id}-fact-${i}`}><dt>{label}</dt><dd>{text}</dd></div>)}</dl>
        </div>
        <aside className="uk-comparison-aside" data-testid={`us-${item.id}-considerations`}>
          <span className="uk-eyebrow">Worth considering when</span>
          <ul>{item.considerations.map(text => <li key={text}><Check size={17} aria-hidden="true" /><span>{text}</span></li>)}</ul>
          <p className="uk-fineprint">{item.note}</p>
          <UsEnquireButton secondary onClick={() => onEnquire(item.short)} testId={`us-enquire-${item.id}`}>Discuss this structure</UsEnquireButton>
        </aside>
      </TabsContent>)}
    </Tabs>
  </section>
);
